import {
  makeObservable,
  observable,
  action,
  computed,
  runInAction,
} from "mobx";
import { IObservableInitialState } from "../../models/ICommon";
import * as baseService from "../service/base-service";
import URLConstants from "../../constants/url.constants";
import toast from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { getLanguageFromLocalStorage } from "../../helpers/local-stotrage-helper";
import moment from "moment";
import { DATE_FORMAT, DATE_TIME_FORMAT, DATE_TIME_FORMAT_FILENAME, emptyValue, emptyValueHyphen, fotaView, getEffectiveDateForSchedule, getEffectiveDateTime } from "../../constants/common-constants";
import { initialValues} from '../initial-state/schedule-firmware-update-state';
import { ISchedulerDetailVm, ISchedulerHistoryList, ISchedulerHistoryListVm } from "../../models/response/IReleaseSchedulerHistoryResponse";
import { IAddReleaseScheduler, IUpdateReleaseScheduler } from "../../models/Form/IAddUpdateReleaseScheduler";
import { initialReleaseSchedulerHistoryState } from "../initial-state/get-all-release-schedule-history-state";
import { initialFotaSchedulerDeviceStatusState } from "../initial-state/get-fota-schedule-device-status-state";
import Papa from "papaparse";
import { IDeviceFotaStatusListVm, IDeviceFotaStatusList } from "../../models/response/IFotaSchedulerDeviceStatusResponse";
import FotaStatusEnum from "../../constants/fota-status-enum";
import { IFotaDeviceStatusFilter } from "../../models/response/IFotaResponse";

export class ReleaseSchedulerHistoryStore {
  initialStateValue = {
    success: false,
    error: '',
    inProgress: false
  }
  error: string | null = null;
  inProgress: boolean = false;

  addUpdateReleaseSchedulerHistoryState: IObservableInitialState = { ...this.initialStateValue }

  releaseSchedulerHistoryList: ISchedulerHistoryListVm = initialReleaseSchedulerHistoryState;
  releaseSchedulerHistoryState: IObservableInitialState = { ...this.initialStateValue }
  
  schedulerDeviceStatusList: IDeviceFotaStatusListVm = initialFotaSchedulerDeviceStatusState;
  schedulerDeviceStatusListState: IObservableInitialState = { ...this.initialStateValue }
  
  deleteReleaseSchedulerHistoryState: IObservableInitialState = { ...this.initialStateValue }
  releaseSchedulerHistory: ISchedulerDetailVm | undefined = undefined;  
  
  downloadReleaseSchedulerDeviceListState: IObservableInitialState = { ...this.initialStateValue }
  
  initialFilter: IFotaDeviceStatusFilter = {
      SearchBy:-1,
      ICCID:"",
      Status:0,
      isFilterActive: false
  }

  filterDetails: IFotaDeviceStatusFilter = {
      ...this.initialFilter
  }

  constructor() {
    makeObservable(this, {
      inProgress: observable,
      error: observable,
      
      releaseSchedulerHistoryList: observable,
      releaseSchedulerHistory: observable,
      releaseSchedulerHistoryState: observable,
      addUpdateReleaseSchedulerHistoryState: observable,
      downloadReleaseSchedulerDeviceListState: observable,
      deleteReleaseSchedulerHistoryState: observable,
      
      schedulerDeviceStatusList: observable,
      schedulerDeviceStatusListState: observable,
      filterDetails: observable,
      
      GetReleaseSchedulerHistoryListService: action,
      GetFotaSchedulerDeviceStatusListService: action,
      GetReleaseSchedulerHistoryByIdService: action,
      DownloadReleaseSchedulerDeviceListBySchedulerIdService: action,
      AddReleaseSchedulerHistoryService: action,
      UpdateReleaseSchedulerHistoryService: action,
      DeleteReleaseSchedulerHistoryService: action,
      
      reset: action,
      resetStore: action,
      resetReleaseSchedulerHistoryState: action,
      resetAddUpdateReleaseSchedulerHistoryState: action,
      resetDeleteReleaseSchedulerHistoryState: action,
      resetDownloadReleaseSchedulerDeviceListState: action,
      resetSchedulerDeviceStatusListState: action,
      setFilterDetail: action,
      
      getReleaseSchedulerHistoryList: computed,
      getFotaSchedulerDeviceStratusList: computed,
      getReleaseSchedulerHistoryDetail: computed,
      getReleaseSchedulerHistory: computed,
      
    });
  }

  /**
   * Fetches a list of ReleaseSchedulerHistory items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetReleaseSchedulerHistoryListService = (currentPage: number, pageSize: number, selectedView: string, releaseId: number) => {
    runInAction(() => (this.inProgress = true));
    let url = "";
    switch(selectedView){
      case fotaView.MODEM:
        url = `${URLConstants.FotaModemRelease}/${releaseId}/Scheduler/History/List?PageNo=${currentPage}&PageSize=${pageSize}`;
        break
        case fotaView.JET:
          url = `${URLConstants.FotaJetRelease}/${releaseId}/Scheduler/History/List?PageNo=${currentPage}&PageSize=${pageSize}`;
          break
        default:
        url = `${URLConstants.FotaHostRelease}/${releaseId}/Scheduler/History/List?PageNo=${currentPage}&PageSize=${pageSize}`;
        // url = `${URLConstants.ReleaseSchedulerHistoryList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    }
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ISchedulerHistoryListVm>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.releaseSchedulerHistoryList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err))
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map releaseSchedulerHistoryList to ReleaseSchedulerHistory List suitable for Grid Component.
    * @returns Initial ReleaseSchedulerHistory Details
    */
  get getReleaseSchedulerHistoryList(): ISchedulerHistoryList[] {
    if (this.releaseSchedulerHistoryList && this.releaseSchedulerHistoryList?.History.length > 0)
        return this.releaseSchedulerHistoryList?.History.map((history) => {
            let language = getLanguageFromLocalStorage();
            let scheduleDate = (history.ScheduleDate && history.ScheduleDate !== "1970-01-01")
            ? moment(history.ScheduleDate, DATE_TIME_FORMAT).format(DATE_TIME_FORMAT)
            : "";
            return {
                Id: history.Id,
                Description: history.Description ? history.Description : "",
                ScheduleDate: scheduleDate,
                ICCIDs: history.ICCIDs,
                CreatedBy: history.CreatedBy,
                UpdatedBy: history.UpdatedBy,
                UpdatedDate: history.UpdatedDate ? moment(history.UpdatedDate).format(DATE_TIME_FORMAT) : "",
                Language: language,
                NoOfDevicesInSchedule: history.NoOfDevicesInSchedule || 0,
                isDownload: true,
                isEdit: history.ScheduleDate ? (new Date(history.ScheduleDate) > new Date() ? true : false) : false,
                isDelete: true,
            }
        })
    return [];
  }

  /**
   * Fetches a list of FotaSchedulerDeviceStatus items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetFotaSchedulerDeviceStatusListService = (currentPage: number, pageSize: number, selectedView: string, schedulerId: number, filter: any) => {
    runInAction(() => (this.schedulerDeviceStatusListState.inProgress = true));
    let url = "";
    switch(selectedView){
      case fotaView.MODEM:
        url = `${URLConstants.FotaModemScheduler}/Devices/Fota/Status/List`;
        break
        case fotaView.JET:
          url = `${URLConstants.FotaJetScheduler}/Devices/Fota/Status/List`;
          break
        default:
        url = `${URLConstants.FotaHostScheduler}/Devices/Fota/Status/List`;
    }
    let tempSearchBy:number = parseInt(filter.SearchBy)
    let requestBody = {
        Id:schedulerId,
        ICCID: filter.ICCID,
        SearchBy: tempSearchBy > 0 ? tempSearchBy : 0,
        Status: filter.Status,
        PaymentStatus: filter.PaymentStatus,
        PagingDetails: {
            PageNo: currentPage,
            PageSize: pageSize,
            TotalPages: 0,
            TotalRecords: 0
        },
    }
    return baseService
      .postRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<IDeviceFotaStatusListVm>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.schedulerDeviceStatusList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err))
      })
      .finally(() => {
        runInAction(() => (this.schedulerDeviceStatusListState.inProgress = false));
      });
  };

  /**
    * This function is used to map releaseSchedulerHistoryList to ReleaseSchedulerHistory List suitable for Grid Component.
    * @returns Initial ReleaseSchedulerHistory Details
    */
  get getFotaSchedulerDeviceStratusList(): IDeviceFotaStatusList[] {
    if (this.schedulerDeviceStatusList && this.schedulerDeviceStatusList?.DevicesFotaStatusHistory.length > 0)
        return this.schedulerDeviceStatusList?.DevicesFotaStatusHistory.map((deviceStatus) => {
            let language = getLanguageFromLocalStorage();
            return {
                Id: deviceStatus.Id,
                ICCID: deviceStatus.ICCID ?? "",
                Status: FotaStatusEnum[deviceStatus.Status],
                StatusValue: deviceStatus.Status,
                TotalSegment: deviceStatus.TotalSegment,
                LastSegmentNoRequestedByDevice: deviceStatus.LastSegmentNoRequestedByDevice,
                LastRebootMessage: deviceStatus.LastRebootMessage,
                Language: language,
                LastRequestTimestamp: deviceStatus.LastRequestTimestamp ? moment(deviceStatus.LastRequestTimestamp, DATE_TIME_FORMAT).format(DATE_TIME_FORMAT) : "",
            }
        })
    return [];
  }

  resetSchedulerDeviceStatusListState = () =>{
    this.schedulerDeviceStatusList = initialFotaSchedulerDeviceStatusState;
    this.schedulerDeviceStatusListState = {...this.initialStateValue};
  }

  getBaseURL = (selectedView : string) => {
    let baseUrl: string = "";
    switch(selectedView){
      case fotaView.MODEM:
        baseUrl = URLConstants.FotaModemReleaseScheduler;
        break
      case fotaView.JET:
        baseUrl = URLConstants.FotaJetReleaseScheduler;
        break
      default:
        baseUrl = URLConstants.FotaHostReleaseScheduler;
    }
    return baseUrl;
  }
  /**
   * Fetches ReleaseSchedulerHistory item details by ID.
   * @param id - ID of the ReleaseSchedulerHistory item.
   */
  GetReleaseSchedulerHistoryByIdService = (id: number, selectedView: string) => {
    runInAction(() => (this.releaseSchedulerHistoryState.inProgress = true));
    let url = "";
    switch(selectedView){
      case fotaView.MODEM:
        url = `${URLConstants.FotaModemScheduler}/${id}/Details`;
        break
      case fotaView.JET:
        url = `${URLConstants.FotaJetScheduler}/${id}/Details`;
        break
      default:
        url = `${URLConstants.FotaHostScheduler}/${id}/Details`;
    }
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ISchedulerDetailVm>>) => {
        if (response.data.Error) {
          // runInAction(
          //   () => (this.releaseSchedulerHistoryState.error = response.data.Message)
          // );
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.releaseSchedulerHistory = {
              ...response.data.Data,
            };
            this.releaseSchedulerHistoryState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
        // runInAction(() => (this.releaseSchedulerHistoryState.error = err));
      })
      .finally(() => {
        runInAction(() => (this.releaseSchedulerHistoryState.inProgress = false));
      });
  };

  generateAndDownloadCSV = (selectedDevices: any, fileName: string) => {
      const csv = Papa.unparse(selectedDevices);
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download =  fileName + ".csv";
      document.body.appendChild(a);
      a.click();
      toast.success(formatMessage("download_started_successfully"));
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
  };
  /**
   * downloads releaseSchedulerDeviceListBySchedulerIdService item details by ID.
   * @param id - ID of the ReleaseSchedulerHistory item.
   */
  DownloadReleaseSchedulerDeviceListBySchedulerIdService = (id: number, selectedView: string) => {
    runInAction(() => (this.downloadReleaseSchedulerDeviceListState.inProgress = true));
    let url = "";
    switch(selectedView){
      case fotaView.MODEM:
        url = `${URLConstants.FotaModemScheduler}/${id}/Details`;
        break
      case fotaView.JET:
        url = `${URLConstants.FotaJetScheduler}/${id}/Details`;
        break
      default:
        url = `${URLConstants.FotaHostScheduler}/${id}/Details`;
    }
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ISchedulerDetailVm>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            let data = (response.data.Data && response.data.Data?.ICCIDs) ? response.data.Data.ICCIDs : []
            if(data.length > 0)
            {
                let iccidDataList = data.map((value:string)=>{return {ICCID: value}})
                this.generateAndDownloadCSV(iccidDataList, moment(new Date()).format(DATE_TIME_FORMAT_FILENAME) + "ScheduledDeviceList");
            }
            else
            toast.error(formatMessage("no_device_associated_with_order"));
            this.downloadReleaseSchedulerDeviceListState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
        // runInAction(() => (this.downloadReleaseSchedulerDeviceListState.error = err));
      })
      .finally(() => {
        runInAction(() => (this.downloadReleaseSchedulerDeviceListState.inProgress = false));
      });
  };

  resetDownloadReleaseSchedulerDeviceListState = () =>{
    this.downloadReleaseSchedulerDeviceListState = {...this.initialStateValue};
  }

  /**
   * Returns releaseSchedulerHistory which were fetched by Id
   */
  get getReleaseSchedulerHistory(): IAddReleaseScheduler {
    if (this.releaseSchedulerHistory) 
      return {
        ScheduleDate: (this.releaseSchedulerHistory.ScheduleDate && this.releaseSchedulerHistory.ScheduleDate !== "1970-01-01") ? moment(this.releaseSchedulerHistory.ScheduleDate).format(DATE_FORMAT) : "",
        Description: this.releaseSchedulerHistory.Description,
        IsUpdateNow: "0",
        WantToUpdateDevices: "false",
        IsAppliedOnGroup: "false",
        ICCIDs: this.releaseSchedulerHistory.ICCIDs,
        ICCIDsFile: "",
        ICCIDsFileContent: "",
        GroupIds: [],
    };
    return {...initialValues, ScheduleDate: getEffectiveDateForSchedule()};
  }
  
  /**
   * Returns releaseSchedulerHistoryDetail which were fetched by Id
   */
  get getReleaseSchedulerHistoryDetail(): ISchedulerDetailVm | undefined{
    if (this.releaseSchedulerHistory) 
      return {
        Id: this.releaseSchedulerHistory.Id,
        ICCIDs: this.releaseSchedulerHistory.ICCIDs,
        ScheduleDate: (this.releaseSchedulerHistory.ScheduleDate && this.releaseSchedulerHistory.ScheduleDate !== "1970-01-01T00:00:00.000Z") ? moment(this.releaseSchedulerHistory.ScheduleDate).format(DATE_FORMAT) : "",
        Description: this.releaseSchedulerHistory.Description,
        NoOfDevicesInSchedule: this.releaseSchedulerHistory.NoOfDevicesInSchedule || 0,
        UpdatedDate: (this.releaseSchedulerHistory.UpdatedDate && this.releaseSchedulerHistory.UpdatedDate !== "1970-01-01T00:00:00.000Z") ? moment(this.releaseSchedulerHistory.UpdatedDate).format(DATE_TIME_FORMAT) : "",
    };
  }

  resetReleaseSchedulerHistoryState = () =>{
    this.releaseSchedulerHistory = undefined;
    this.releaseSchedulerHistoryState = {...this.initialStateValue};
  }

  /**
   * Adds or updates a ReleaseSchedulerHistory for SystemAdmin.
   * @param data - ReleaseSchedulerHistory item data.
   */
  AddReleaseSchedulerHistoryService = (data: IAddReleaseScheduler,  selectedView: string, relaseId: number) => {
    this.addUpdateReleaseSchedulerHistoryState.inProgress = true;
    let url = `${this.getBaseURL(selectedView)}`;
    return baseService.postRequest(url, {...data, ReleaseId: relaseId})
    .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            toast.success(formatMessage(response.data?.Message))
            this.addUpdateReleaseSchedulerHistoryState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateReleaseSchedulerHistoryState.inProgress = false;
      });
  };

  /**
   * Updates a ReleaseSchedulerHistory for SystemAdmin.
   * @param data - ReleaseSchedulerHistory item data.
   */
  UpdateReleaseSchedulerHistoryService = (data: IUpdateReleaseScheduler, selectedView: string) => {
    this.addUpdateReleaseSchedulerHistoryState.inProgress = true;
    let url = `${this.getBaseURL(selectedView)}`;
    return baseService.putRequest(url, {...data})
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            toast.success(formatMessage(response.data?.Message))
            this.addUpdateReleaseSchedulerHistoryState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateReleaseSchedulerHistoryState.inProgress = false;
      });
  };

  resetAddUpdateReleaseSchedulerHistoryState = () =>{
    this.addUpdateReleaseSchedulerHistoryState = {...this.initialStateValue};
  }

  /**
    * This function is used to Delete User by calling an API.
    * @param id : The User Identifier
    * @returns 
    */
  DeleteReleaseSchedulerHistoryService = (schedulerId: number, selectedView: string) => {
    this.deleteReleaseSchedulerHistoryState.inProgress = true;
    let url = `${this.getBaseURL(selectedView)}/${schedulerId}`;
    return baseService.deleteRequest(url)
        .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
            if (response.data.Error) {
                this.deleteReleaseSchedulerHistoryState.error = response.data.Message;
                toast.error(formatMessage(response.data.Message));
            }
            else this.deleteReleaseSchedulerHistoryState.success = true;
        })
        .catch((err: string) => {
            this.deleteReleaseSchedulerHistoryState.error = err;
            toast.error(formatMessage(err));
        }).finally(action(() => { this.deleteReleaseSchedulerHistoryState.inProgress = false; }));
  }

  resetDeleteReleaseSchedulerHistoryState = () => {
    this.deleteReleaseSchedulerHistoryState = {...this.initialStateValue};
  };

  /**
   * Resets all observables to their initial values.
   */
  reset = () => {
    this.error = "";
    this.inProgress = false;
  };

  resetStore = () => {
    this.addUpdateReleaseSchedulerHistoryState = {...this.initialStateValue};
    this.releaseSchedulerHistoryState = {...this.initialStateValue};
    this.deleteReleaseSchedulerHistoryState = {...this.initialStateValue};
    this.downloadReleaseSchedulerDeviceListState = {...this.initialStateValue};
    this.error = null;
    this.inProgress = false;
    this.releaseSchedulerHistoryList = initialReleaseSchedulerHistoryState;
    this.schedulerDeviceStatusList = initialFotaSchedulerDeviceStatusState;
    this.schedulerDeviceStatusListState = {...this.initialStateValue};
    this.releaseSchedulerHistory = undefined;
    this.filterDetails = {...this.initialFilter}
  };

  setFilterDetail = (filter: any) => {
    this.filterDetails = {...filter};
}

}
const fotaStore = new ReleaseSchedulerHistoryStore();
export default fotaStore;
